import React, { createContext, useState, useEffect } from "react";
import { BASE_URL } from "../api/api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // { role: 'NetworkAdmin' | 'NetworkSubAdmin' | 'Vendor', email: string }
  const [loading, setLoading] = useState(true);
  const [loginStatus, setLoginStatus] = useState(false);

  const login = async (credentials) => {
    // Determine role: keep existing mappings for admin/subadmin, treat others as Vendor
    let role;
    if (credentials.email === "networkadm@gmail.com") {
      role = "NetworkAdmin";
    } else if (credentials.email === "networksub@gmail.com") {
      role = "NetworkSubAdmin";
    } else if (credentials.email === "finance@gmail.com") {
      role = "finance";
    } else {
      role = "ServiceProvider";
    }

    try {
      const response = await fetch(`${BASE_URL}/UserLogin`, {
        method: "POST",
        headers: {
          accept: "text/plain",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: credentials.email,
          password: credentials.password,
          role: role,
        }),
      });

      console.log("API response status:", response);
      if (!response.ok) {
        let errorMessage = "Invalid credentials";
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch (e) {
          console.error("Failed to parse error response:", e);
        }
        throw new Error(errorMessage);
      }

      let data;
      try {
        data = await response.json();
      } catch (e) {
        console.error("Failed to parse API response:", e);
        throw new Error("Invalid API response format");
      }
      console.log("Raw API response:", data);

      // Check API response for success
      if (data.status !== true) {
        throw new Error(data.message || "Login failed");
      }

      // Build user object
      const userData = {
        role: role,
        email: credentials.email,
      };

      setUser(userData);
      console.log("testt", data)
      localStorage.setItem("ServiceProviderName", data.name)
      localStorage.setItem("user", JSON.stringify(userData));
      setLoginStatus(true);
      return userData;
    } catch (error) {
      console.error("Login error:", error.message);
      throw new Error(error.message || "Login failed");
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("ServiceProviderName");
    setLoginStatus(false);
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, loginStatus }}>
      {children}
    </AuthContext.Provider>
  );
};
